class User {
    id = null;
    first_name = '';
    last_name = '';
    email = '';
    password = '';
    active = true;
    user_role_id = 3;
    contact_number = '';

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default User;
